'use strict';

var SystemStatusServiceSentDirective = function SystemStatusServiceSentDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-service-sent.html'),
    controller: 'SystemStatusServiceSentController',
    link: function link(scope, element) {
      var modalElement = element.find('#system-status-service-sent-modal');
      function showModal(event, data) {
        scope.modalData = data.entityData;
        modalElement.modal('show');
        scope.$broadcast('statusMessage:show');
      }
      scope.$on('grid:icon-click', showModal);
    }
  };
};
SystemStatusServiceSentDirective.$inject = [];
module.exports = SystemStatusServiceSentDirective;